'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);
var _CellGalleryItem = require('./CellGalleryItem');var _CellGalleryItem2 = _interopRequireDefault(_CellGalleryItem);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

MemoizedGallerySwiper = function (_Component) {_inherits(MemoizedGallerySwiper, _Component);
  function MemoizedGallerySwiper(props) {_classCallCheck(this, MemoizedGallerySwiper);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



















    renderGalleryItem = function (item) {return (
        _react2.default.createElement(_CellGalleryItem2.default, { key: item.thumbnail, item: item }));};_this.debouncedOnUpdate = (0, _debounce2.default)(function () {_this.props.onUpdate();}, 0);return _this;}MemoizedGallerySwiper.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps) {var isImagesChanged = newProps.images.length !== this.props.images.length;var isRtlChanged = newProps.rtl !== this.props.rtl;var isLoopChanged = this.props.loop !== newProps.loop;var isAutoplayChanged = !!this.props.autoplay !== !!newProps.autoplay;return isRtlChanged || isImagesChanged || isLoopChanged || isAutoplayChanged;};MemoizedGallerySwiper.prototype.componentDidUpdate = function componentDidUpdate() {this.debouncedOnUpdate();};MemoizedGallerySwiper.prototype.


  render = function render() {var _props =
    this.props,images = _props.images,setSwiperRef = _props.setSwiperRef,params = _objectWithoutProperties(_props, ['images', 'setSwiperRef']);

    return (
      _react2.default.createElement(_reactIdSwiper2.default, _extends({}, params, { ref: setSwiperRef }),
        images.map(function (item, idx) {return (
            _react2.default.createElement('div', { key: item.thumbnail || idx, className: 'swiper-slide' },
              _react2.default.createElement(_CellGalleryItem2.default, { item: item })));})));




  };return MemoizedGallerySwiper;}(_react.Component);exports.default = MemoizedGallerySwiper;


MemoizedGallerySwiper.propTypes = {
  images: _propTypes2.default.array,
  onUpdate: _propTypes2.default.func,
  rtl: _propTypes2.default.bool,
  loop: _propTypes2.default.bool,
  autoplay: _propTypes2.default.object,
  setSwiperRef: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellGallery/MemoizedGallerySwiper.js
// module id = 2768
// module chunks = 0